import { h, Component } from 'preact';
import { Router } from 'preact-router';
import mixpanel from 'mixpanel-browser';

import Header from './header';
import Footer from './footer';
import Home from '../routes/home';
import About from '../routes/about';
import Courses from '../routes/courses';
import Course from '../routes/courses/course';
import MobileHeader from '../components/mobile-header';
// import Home from 'async!../routes/home';
// import Profile from 'async!../routes/profile';

if (module.hot) {
	require('preact/debug');
}

export default class App extends Component {
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	constructor(props) {
		super(props);
		mixpanel.init("3e7916a6e65e76ae49e4f9984b1ff3a5")
	}

	handleRoute = e => {
		if (typeof window !== "undefined") {
			window.scrollTo(0,0);
		}
		this.currentUrl = e.url;
		mixpanel.track('pageview');
	};

	render() {
		return (
			<div id="app">
				<Header />
				<MobileHeader>
					<div id="content">
						<Router onChange={this.handleRoute}>
							<Home path="/" />
							<About path="/about" />
							<Courses path="/courses" />
							<Course path="/courses/:blockIndex/:courseIndex" />
						</Router>
					</div>
					<Footer />
				</MobileHeader>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js